import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useCarousel } from './useCarousel'
import type { WithClassAsProps } from './interface'
import { cn } from '@/utils/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselItem',
  props: {
    class: {}
  },
  setup(__props: any) {

const props = __props

const { orientation } = useCarousel()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "group",
    "aria-roledescription": "slide",
    class: _normalizeClass(_unref(cn)(
      'min-w-0 shrink-0 grow-0 basis-full',
      _unref(orientation) === 'horizontal' ? 'pl-4' : 'pt-4',
      props.class,
    ))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})